import { ArrowDown, ArrowUp, Edit2, Loader2, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

export function CategoriesTab({
  loading,
  categories,
  reordering,
  onMoveCategory,
  onEditCategory,
  onDeleteCategory,
}) {
  if (loading) {
    return (
      <div className="text-center py-12">
        <Loader2 className="w-8 h-8 animate-spin mx-auto text-[#1aa59a]" />
      </div>
    );
  }

  const sortedCategories = [...categories].sort((a, b) => (a.order || 0) - (b.order || 0));

  return (
    <div className="space-y-2">
      <div className="text-xs text-gray-500 flex items-center gap-2 mb-2 bg-blue-50 p-2 rounded-lg">
        <ArrowUp className="w-3 h-3" />
        <ArrowDown className="w-3 h-3" />
        Use the arrows to reorder categories. Changes affect both the filter bar and All view.
      </div>
      {sortedCategories.map((cat, idx) => (
        <Card key={cat.id} className="overflow-hidden">
          <div className="flex items-center p-3 gap-3">
            <div className="flex flex-col gap-0.5">
              <button
                onClick={() => onMoveCategory(cat, "up")}
                disabled={idx === 0 || reordering}
                className="p-1 hover:bg-gray-100 rounded disabled:opacity-30 disabled:cursor-not-allowed"
              >
                <ArrowUp className="w-3.5 h-3.5 text-gray-500" />
              </button>
              <button
                onClick={() => onMoveCategory(cat, "down")}
                disabled={idx === sortedCategories.length - 1 || reordering}
                className="p-1 hover:bg-gray-100 rounded disabled:opacity-30 disabled:cursor-not-allowed"
              >
                <ArrowDown className="w-3.5 h-3.5 text-gray-500" />
              </button>
            </div>
            <div
              className="w-10 h-10 rounded-lg flex items-center justify-center text-white flex-shrink-0"
              style={{ backgroundColor: cat.color }}
            >
              {cat.image_base64 ? (
                <img src={cat.image_base64} alt="" className="w-full h-full rounded-lg object-cover" loading="lazy" />
              ) : (
                <span>🍽️</span>
              )}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="font-medium text-sm">{cat.label}</h3>
                {cat.is_rotating && (
                  <span className="text-xs bg-purple-100 text-purple-700 px-1.5 py-0.5 rounded font-medium">
                    🔄 Rotating
                  </span>
                )}
              </div>
              <p className="text-xs text-gray-500">Key: {cat.key} | Order: {cat.order || 0}</p>
            </div>
            <div className="flex gap-1">
              <Button size="sm" variant="outline" onClick={() => onEditCategory(cat)} className="h-8 w-8 p-0">
                <Edit2 className="w-3.5 h-3.5" />
              </Button>
              <Button
                size="sm"
                variant="outline"
                className="text-red-500 h-8 w-8 p-0"
                onClick={() => onDeleteCategory(cat)}
              >
                <Trash2 className="w-3.5 h-3.5" />
              </Button>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
